import { environment } from '../../environments/environment';

interface Scripts {
  name: string;
  src: string;
  loc: string;
}  

export const ScriptStore: Scripts[] = [
  { name: 'adobedtm', src: environment.analytics_script, loc: 'head' },
  { name: 'adobebottom', src: environment.adobe_bottom_script, loc: 'body' }
];


// WEBPACK FOOTER //
// ./src/app/service/script.store.ts